module.exports = __webpack_public_path__ + "img/2_251.50aed6d6.png";